import React, { useState, useEffect } from "react";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { IoMdAddCircle } from "react-icons/io";
import AisleRow from "./AisleRow";
import RackRow from "./RackRow";
import ShelfRow from "./ShelfRow";
import BinRow from "./BinRow";

import { toastError, toastSuccess } from "../../../../src/common/Toast";
import { ALREADY_EXIST, 
    ERROR_MESSAGE,
    CUSTOM_SELECT_DROPDOWN_STYLE, 
    SUCCESS_MESSAGE,
 } from "../../../common/Constant";

const LocationRackManagement = (props) => {
    let navigate = useNavigate();
    const token = localStorage.getItem("Token");
    const loginUserId = localStorage.getItem("ID");
    const [LocationList, setLoactionList] = useState([]);
    const [SelectedLocation, setSelectedLocation] = useState([]);
    const [loading, setLoading] = useState(false);
    const [aisleRows, setAisleRows] = useState([]);
    const [binRows, setBinRows] = useState([]);
    const [rackRows, setRackRows] = useState([]);
    const [shelfRows, setShelfRows] = useState([]);

    let LocationsList = [];
    const DataList = LocationList.map((u, i) => {
        LocationsList[i] = { label: u.Name, value: u.Id };
    });

    const handleChangeforLocations = (e) => {
        console.log(e.value);
        setSelectedLocation(e.value)
        axios
            .get(`${config.locationBaseUrl}/locations/rackmanagementfindbyid?id=${e.value}`, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                },
            })
            .then((res) => {
                let Databindlist = res.data.ResponseData
                console.log("e.value", res.data.ResponseData);
                // console.log(res.data.ResponseData.LocationsAisile);
                setAisleRows(Databindlist.LocationsAisile)
                setBinRows(Databindlist.LocationsBin);
                setRackRows(Databindlist.LocationsRack);
                setShelfRows(Databindlist.LocationsShelf);
                // const AccountTypeData = res.data.ResponseData[0];
                // // console.log(AccountTypeData);
                // const data = {
                //     ID: AccountTypeData.ID,
                //     Name: AccountTypeData.Name,
                // };
                // setFormValues(data);
                // setLoading(false);
            })
            .catch((err) => {
                // setLoading(false);
            });
    }

    // Add Row of Aisle
    const addAislerows = () => {
        setAisleRows([
            ...aisleRows,
            {
                AisleId: 0,
                AisleName: "",
            },
        ]);
    };

    // Add Row of Bin
    const addBinrows = () => {
        setBinRows([
            ...binRows,
            {
                BinId: 0,
                BinName: "",
            },
        ]);
    };

    // Add Row of Shelf
    const addShelfrows = () => {
        setShelfRows([
            ...shelfRows,
            {
                ShelfId: 0,
                ShelfName: "",
            },
        ]);
    };

    // Add Row of Rack
    const addRackerows = () => {
        setRackRows([
            ...rackRows,
            {
                RackId: 0,
                RackName: "",
            },
        ]);
    };

    // HandleChanges of Aisle
    const handleChangeAisleRow = (index, event) => {
        console.log(event.target.value);
        console.log(event.target.name);

        let name, values;
        name = event.target.name;
        values = event.target.value;
        const rowsInput = [...aisleRows];
        rowsInput[index][name] = values;

        console.log(rowsInput);

        setAisleRows(rowsInput);
    };


    // HandleChanges of Bin
    const handleChangeBinRow = (index, event) => {
        console.log(event.target.value);
        console.log(event.target.name);

        let name, values;
        name = event.target.name;
        values = event.target.value;
        const rowsInput = [...binRows];
        rowsInput[index][name] = values;

        console.log(rowsInput);

        setBinRows(rowsInput);
    };


    // HandleChanges of Shelf
    const handleChangeShelfRow = (index, event) => {
        console.log(event.target.value);
        console.log(event.target.name);

        let name, values;
        name = event.target.name;
        values = event.target.value;
        const rowsInput = [...shelfRows];
        rowsInput[index][name] = values;

        console.log(rowsInput);

        setShelfRows(rowsInput);
    };


    // HandleChanges of Rack
    const handleChangeRackRow = (index, event) => {
        console.log(event.target.value);
        console.log(event.target.name);

        let name, values;
        name = event.target.name;
        values = event.target.value;
        const rowsInput = [...rackRows];
        rowsInput[index][name] = values;

        console.log(rowsInput);

        setRackRows(rowsInput);
    };

    //delete Aisle
    const deleteAisle = (index) => {
        // console.log(quantity);
        const rows = [...aisleRows];
        rows.splice(index, 1);
        setAisleRows(rows);
    };

    //delete Bin
    const deleteBin = (index) => {
        // console.log(quantity);
        const rows = [...binRows];
        rows.splice(index, 1);
        setBinRows(rows);
    };

    //delete Rack
    const deleteRack = (index) => {
        // console.log(quantity);
        const rows = [...rackRows];
        rows.splice(index, 1);
        setRackRows(rows);
    };

    //delete Shelf
    const deleteShelf = (index) => {
        // console.log(quantity);
        const rows = [...shelfRows];
        rows.splice(index, 1);
        setShelfRows(rows);
    };

    // const selectStyles = {
    //     // dropdown input css
    //     control: (provided, state) => ({
    //       ...provided,
    //       width: "100%",
    //       height: "40px",
    //       position: "relative",
    //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //       boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    //       "&:hover": {
    //         border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //       },
    //     }),
    //     // dropdown menu css
    //     menu: () => ({
    //       boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
    //       position: "absolute",
    //       "z-index": "999",
    //       background: "#f8f8f8",
    //       width: "100%",
    //     }),
    //     // dropdown option css
    //     option: (provided, state) => ({
    //       ...provided,
    //       backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
    //       "&:hover": {
    //         backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
    //       },
    //     }),
    //   };

    const handlesubmit = () => {
        console.log("hellooo", SelectedLocation);
        //for Aisle Json
        let LoactionAisledata = aisleRows.filter(function (aisleRows) {
            return aisleRows.AisleName != "";
        })
        const LoactionAisleobject = {};
        LoactionAisleobject.AisleXml = LoactionAisledata;
        let Aislejsonstring = '';
        Aislejsonstring = JSON.stringify(LoactionAisleobject);
        console.log("Aislejsonstring==>>", Aislejsonstring);
        console.log("LoactionAisleobject==>>>", LoactionAisleobject);

        //for Bin Json
        let LoactionBindata = binRows.filter(function (binRows) {
            return binRows.BinName != "";
        })
        const LoactionBinobject = {};
        LoactionBinobject.BinXml = LoactionBindata;
        let Binjsonstring = '';
        Binjsonstring = JSON.stringify(LoactionBinobject);
        console.log("Binjsonstring==>>", Binjsonstring);
        console.log("LoactionBinobject==>>>", LoactionBinobject);

        //for Shelf Json
        let LoactionShelfdata = shelfRows.filter(function (shelfRows) {
            return shelfRows.ShelfName != "";
        })
        const LoactionShelfobject = {};
        LoactionShelfobject.ShelfXml = LoactionShelfdata;
        let Shelfjsonstring = '';
        Shelfjsonstring = JSON.stringify(LoactionShelfobject);
        console.log("Shelfjsonstring==>>", Shelfjsonstring);
        console.log("LoactionShelfobject==>>>", LoactionShelfobject);

        //for Rack Json
        let LoactionRackdata = rackRows.filter(function (rackRows) {
            return rackRows.RackName != "";
        })
        const LoactionRackobject = {};
        LoactionRackobject.RackXml = LoactionRackdata;
        let Rackjsonstring = '';
        Rackjsonstring = JSON.stringify(LoactionRackobject);
        console.log("Rackjsonstring==>>", Rackjsonstring);
        console.log("LoactionRackobject==>>>", LoactionRackobject);

        let LocationData = {
            xmllocationsaisle: Aislejsonstring,
            xmllocationsbin: Binjsonstring,
            xmllocationsrack: Rackjsonstring,
            xmllocationsshelf: Shelfjsonstring,
            locationid: SelectedLocation,
            loginuserid: loginUserId
        }

        setLoading(true);
        axios
            .post(`${config.locationBaseUrl}/locations/rackmanagementupsert`, LocationData, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: token,
                },
            })
            .then((res) => {
                console.log("ReponseData",res.data)
                if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
                    toastSuccess(SUCCESS_MESSAGE);
                    window.location.reload();
                } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                ) {
                    toastError("Email" + ALREADY_EXIST);
                } else {
                    toastError(ERROR_MESSAGE);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    useEffect(() => {
        axios
            .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                },
            })
            .then((res) => {
                console.log("::>>>>>", res.data.ResponseData);
                setLoactionList(res.data.ResponseData);
                // setLocationsData(res.data.ResponseData);
                return res;
            });
    }, [])

    return (
        <>
            <Sidebar />

            <Loader loading={loading} />
            <div className="page-wrapper cardhead">
                <div className="content container-fluid">
                    {/* Page Header */}
                    <div className="page-header" 
                    style={{
                        position: "fixed",
                        top: "2px",
                        zIndex: "999",
                      }}>
                        <div className="row mb-4 breadcrumb-position">
                            
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Rack Management System </li>
                                </ul>
                          
                        </div>
                    </div>
                    <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4"></div>
            <div>
              <div className="btn-group pull-right ms-2 ">
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    style={{ borderRadius: "5px", padding: "8px" }}
                    onClick={() => navigate("/locations")}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
                    <div>
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">Manage Rack</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <label className="col-form-label col-md-2 form-label">
                                                Locations
                                            </label>
                                            <div className="col-md-10">
                                                <Select
                                                    // value={
                                                    //     ChartOfAccountTypeList.find(
                                                    //         (option) =>
                                                    //             option.value === SelectedChartofAccount.value
                                                    //     ) || ""
                                                    // }
                                                    onChange={(event) => handleChangeforLocations(event)}
                                                    options={LocationsList}
                                                    backspaceRemovesValue={false}
                                                    controlShouldRenderValue={true}
                                                    isClearable={true}
                                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                                    id="AccountType"
                                                    name="AccountType"
                                                    className="custom-search-select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    {/* Aisle */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <label className="col-form-label col-md-2 form-label">
                                                Aisle
                                            </label>
                                            <div className="col-md-10">
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th width="80%">Name</th>
                                                                <th width="10%">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <AisleRow
                                                                rowsData={aisleRows}
                                                                deleteTableRows={deleteAisle}
                                                                handleChange={handleChangeAisleRow}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-dark"
                                                        onClick={addAislerows}
                                                    >
                                                        <IoMdAddCircle />
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Rack */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <label className="col-form-label col-md-2 form-label">
                                                Rack
                                            </label>
                                            <div className="col-md-10">
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th width="80%">Name</th>
                                                                <th width="10%">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <RackRow
                                                                rowsData={rackRows}
                                                                deleteTableRows={deleteRack}
                                                                handleChange={handleChangeRackRow}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-dark"
                                                        onClick={addRackerows}
                                                    >
                                                        <IoMdAddCircle />
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    {/* Shelf */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <label className="col-form-label col-md-2 form-label">
                                                Shelf
                                            </label>
                                            <div className="col-md-10">
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th width="80%">Name</th>
                                                                <th width="10%">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <ShelfRow
                                                                rowsData={shelfRows}
                                                                deleteTableRows={deleteShelf}
                                                                handleChange={handleChangeShelfRow}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-dark"
                                                        onClick={addShelfrows}
                                                    >
                                                        <IoMdAddCircle />
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Bin */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <label className="col-form-label col-md-2 form-label">
                                                Bin
                                            </label>
                                            <div className="col-md-10">
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th width="80%">Name</th>
                                                                <th width="10%">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <BinRow
                                                                rowsData={binRows}
                                                                deleteTableRows={deleteBin}
                                                                handleChange={handleChangeBinRow}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-dark"
                                                        onClick={addBinrows}
                                                    >
                                                        <IoMdAddCircle />
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button
                                        type="submit"
                                        onClick={handlesubmit}
                                        className="btn btn-sm btn-primary btn-md me-1 pull-right"
                                    >
                                        Submit
                                    </button>
                                    {/* <Link
                          to="/price-rules"
                          className="btn btn-dark btn-md me-1 pull-right"
                        >
                          Cancel
                        </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*  */}
        </>
    )
}
export default LocationRackManagement;